import type { InteractionContact } from '@/common/types/interaction';

export type ChangedField = {
  currentValue: string;
  newValue: string;
  propName: string;
};

export enum ContactChangeAction {
  Added = 'added',
  Edited = 'edited',
  Deleted = 'deleted',
  None = 'none',
}

export type ContactChangeDetail<TExtra = object> = {
  id: string;
  type: string;
  label: string;
  baseContact?: InteractionContact;
  changedContact?: InteractionContact;
  action: ContactChangeAction;
  fields: ChangedField[];
} & TExtra;
